import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { UserProfileGatewayService } from '../gateway/user-profile.gateway';
import { Country, TitleList } from '@boels/models';

@Injectable({
  providedIn: 'root',
})
export class UserProfileFacade {
  private userProfileService = inject(UserProfileGatewayService);

  getTitles(): Observable<TitleList> {
    return this.userProfileService.getTitles();
  }

  getCountries(overrideParams?: boolean): Observable<{ countries: Country[] }> {
    return this.userProfileService.getCountries(overrideParams);
  }
}
